import { useState } from 'react';

export const useDropdown = (initialList = [], initialMap = {}) => {
  const [list, setList] = useState(initialList);
  const [map, setMap] = useState(initialMap);

  const setDropdown = (values = [], labelMap = {}) => {
    const tempList = values
      .map((key) => ({
        key,
        label: labelMap[key],
      }))
      .filter((item) => item.label);

    const tempMap = tempList.reduce((acc, { key, label }) => {
      acc[label] = key;
      return acc;
    }, {});

    setList(tempList);
    setMap(tempMap);
  };

  return { list, map, setDropdown };
};
